import { create } from "zustand";
import { persist } from "zustand/middleware";

interface StaffViewState {
  /** When true, a staff member browses the portal exactly as a regular
   *  member — beta-gated menus follow their own beta opt-in only. */
  viewAsMember: boolean;
  setViewAsMember: (v: boolean) => void;
}

/** Staff "god mode" toggle. Staff see every feature-gated menu by default;
 *  the Account page switch flips them into the member's-eye view. Persisted
 *  per browser. Display-only — authorization stays server-side. */
export const useStaffView = create<StaffViewState>()(
  persist(
    (set) => ({
      viewAsMember: false,
      setViewAsMember: (v) => set({ viewAsMember: v }),
    }),
    { name: "staff-view" },
  ),
);
